import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HomepageSEO from './components/HomepageSEO';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import RecommendedGrid from './components/RecommendedGrid';
import LatestList from './components/LatestList';
import FeaturesSection from './components/FeaturesSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <HomepageSEO />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryTabs />
        <RecommendedGrid />
        <LatestList />
        <FeaturesSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}